/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import {
  Button,
  Chip,
  DialogContent,
  DialogTitle,
  Divider,
  FormControlLabel,
  Grid,
  IconButton,
  TextField,
  useTheme,
} from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import _ from "lodash";
import React, { useCallback, useEffect, useState } from "react";
import { useRouteMatch } from "react-router-dom";
import { useForm } from "react-hook-form";
import Authorities from "../../../../auth/authorities";
import withAuthority from "../../../../components/Auth/withAuthority";
import ButtonCommon from "../../../../components/buttons/ButtonCommon";
import AvailabilitySelection from "../../../../components/time/AvailabilitySelection";
import ConfirmDeleteDialog from "../../components/dialogs/ConfirmDeleteDialog";
import ValidationMessage from "../../../../components/validation/ValidationMessage";
import {
  createDiscountInfo,
  deleteDiscountInfo,
  updateDiscountInfo,
} from "../../../../services/eatprestoApp/discountInfoService";
import {
  combineMinuteOfWeekArrays,
  normalizeTimeSelections,
} from "../../../../utils/time-conversions";
import {
  DISCOUNT_TYPE_AMOUNT,
  ERROR_MESSAGE_CREATING_ERROR,
  ERROR_MESSAGE_DELETING_ERROR,
  ERROR_MESSAGE_NOT_AVAILABLE_DISCOUNT_ERROR,
  ERROR_MESSAGE_UPDATING_ERROR,
  ERROR_MESSAGE_VERSION_ERROR,
  INTEGER_NUMBER_PATTERN,
  NODE_STATUS_CREATE,
  SUCCESSFULLY_CREATED,
  SUCCESSFULLY_DELETED,
  SUCCESSFULLY_UPDATED,
} from "../../../../utils/consts";
import { CustomTheme, Theme } from "../../../../types/customTheme";
import ApplyToSelection from "../../../../components/common/ApplyToSelection";
import { DISCOUNT_TYPE_PERCENT } from "../../../../utils/consts";
import SwitchCommon from "../../../../components/switches/SwitchCommon";
import {
  DeliveryTpe,
  HttpStatus,
  submitButtonName,
} from "../../../../utils/enum";
import ConfirmDeleteDialogDefault from "../../components/dialogs/ConfirmDeleteDialogDefault";
import CardCommon from "../../../../components/card/CardCommon";
import TextfieldCommon from "../../../../components/textField/TextfieldCommon";
import DefaultAlert from "../../../../components/alerts/DefaultAlert";
import { convertDecimalPoint } from "../../../../utils/ReplaceIcon";
import {
  areObjectArraysEqual,
  cleanObject,
  listsAreEqual,
} from "../../../../utils/isDeepEqual";
import { Autocomplete } from "@material-ui/lab";
import { KeyboardDatePicker } from "@material-ui/pickers";
import moment from "moment";
import {
  createOfferInfo,
  updateOfferInfo,
} from "../../../../services/eatprestoApp/offersService";
import DialogCommon from "../../../../components/dialogs/DialogCommon";
import DialogCommonDefault from "../../../../components/dialogs/DialogCommonDefault";
import TextfieldDefault from "../../../../components/textField/TextfieldDefault";
import FirstTwoTypesGroup from "./FirstTwoTypesGroup";
import PointsModalContent from "./ProductsModal/ProductsModalContent";
import ThirdTypeGroup from "./ThirdTypeGeoup";
import ProductModal from "./ProductsModal";
import AlertDialog from "../../../../components/alerts/AlertDialog";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    textField: {
      overflowWrap: "break-word",
      wordWrap: "break-word",
    },
    base: {
      padding: "0px 12px 0 12px",
      [theme.breakpoints.up("sm")]: {
        padding: "0px 16px 0 16px",
      },
      borderRadius: 4,
    },
    error: {
      backgroundColor: theme.palette.error.dark,
      borderRadius: "8px 8px 0 0",
      border: `1px solid ${theme.palette.background.entity_border}`,
      padding: 8,
    },
    actionsWrapper: {
      padding: "16px 16px",
      display: "flex",
      justifyContent: "center",
    },
    autoComplete: {
      marginTop: "4px",
      "& .MuiAutocomplete-input": {
        color: theme.palette.custom.orange.contrastText,
      },
      "& .MuiInputBase-root": {
        color: "inherit",
        backgroundColor: theme.palette.background.entity_background,
        borderRadius: 10,
      },
      [`& fieldset`]: {
        border: `1px solid ${theme.palette.background.entity_border_highlight_background}`,
        borderRadius: 10,
        color: theme.palette.custom.orange.contrastText,
      },
      "& .MuiAutocomplete-option": {
        paddingTop: 8,
        paddingBottom: 8,
      },
    },
    datePickerStyle: {
      [`& fieldset`]: {
        borderRadius: "10px",
        border: `1px solid ${theme.palette.background.entity_border}`,
        cursor: "pointer",
      },
      "& .MuiPickersClockPointer-pointer": {
        backgroundColor: `${theme.palette.background.default} !important`,
      },
      "& .MuiPickersClockNumber-clockNumberSelected": {
        backgroundColor: `${theme.palette.background.default} !important`,
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        border: `1px solid ${theme.palette.background.entity_border}`,
      },
      "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: `1px solid ${theme.palette.background.entity_border}`,
      },
    },
    titleColor: {
      color: theme.palette.custom.orange.contrastText,
    },
  }),
);

const offerTypeList = [
  {
    id: "BUY_X_GET_Y_CHEAPEST_DISCOUNTED",
    label: "Buy X Get Y Discounted",
    desc: "Discount the cheapest item(s) when buying multiple predefined items.",
  },
  {
    id: "FIXED_PRICE_FOR_X_ITEMS",
    label: "Fixed Price for X Items",
    desc: "Set a fixed total price when buying a predefined group of items.",
  },
  {
    id: "FIXED_PRICE_FROM_X_LISTS",
    label: "Meal Deal (Pick from Lists)",
    desc: "Offer a fixed price when customers choose one item from each predefined list (e.g. Main, Side, Drink).",
  },
];

const priorityList = [
  { id: 50, label: "50" },
  { id: 100, label: "100" },
  { id: 150, label: "150" },
];

const usageList = [
  { id: "Er user", label: "ER_USER" },
  { id: "Global", label: "GLOBAL" },
];

const platformList = [
  { id: "kiosk", label: "Kiosk" },
  { id: "online", label: "Online" },
  { id: "phone", label: "Phone" },
  { id: "walk_in", label: "Walk in" },
];

const discountMethodList = [
  { id: "PERCENTAGE", label: "Percentage" },
  { id: "FIXED", label: "Fixed" },
  { id: "FREE", label: "Free" },
];

const applyToList = [
  { id: "CHEAPEST", label: "Cheapest" },
  { id: "MOST_EXPENSIVE", label: "Most Expensive" },
];

interface FormData {
  name: string;
  description: string;
  usageCount?: number;
  usageDiscountValue: string;
  usageLimit: number;
  discountGroup: string;
  isAutomaticDiscount: boolean;
  discountCode: string;
  deliveryTypes: [];
  isActive: boolean;
  value: string;
  minOrderPrice: string;
  id?: any;
  locationId?: any;
  discountedQuantity: number;
  discountValue: number;
  fixedTotalPrice: number;
  requiredPick: number;
}
export interface DiscountInfoNodeProps {
  openDialog: any;
  setOpenDialog: any;
  nodeData: any;
  getOfferInfo: any;
  offerItemMap: any;
  setOfferItemMap: any;
  offerName: any;
}

/* Create, delete, and update discount information and users can view all discount information. */
const EditOfferModal: React.FunctionComponent<DiscountInfoNodeProps> = ({
  openDialog,
  setOpenDialog,
  nodeData,
  getOfferInfo,
  offerItemMap,
  setOfferItemMap,
  offerName,
}) => {
  const [deliveryTypesList, setDeliveryTypesList] = useState<any>([]);
  const [deliveryTypesListInitial, setDeliveryTypesListInitial] = useState<any>(
    [],
  );
  const [error, setError] = useState("");
  const [selectedWrapperIdList, setSelectedWrapperIdList] = useState<any>({});
  const [selectedWrapperIdListInitial, setSelectedWrapperIdListInitial] =
    useState<any>({});
  const [selectedWrapperIdListInitialNew, setSelectedWrapperIdListInitialNew] =
    useState<any>({});
  const [groupInfo, setGroupInfo] = useState<any>([]);
  const [groupInfoInitial, setGroupInfoInitial] = useState<any>([]);
  const [isOpenCriticalType, setIsOpenCriticalType] = useState(false);
  const [isOpenPriority, setIsOpenPriority] = useState(false);
  const [isOpenUsageLimitType, setIsOpenUsageLimitType] = useState(false);
  const [isOpenPlatform, setIsOpenPlatform] = useState(false);
  const [isOpenDiscountMethod, setIsOpenDiscountMethod] = useState(false);
  const [isOpenApplyTo, setIsOpenApplyTo] = useState(false);
  const [isActive, setIsActive] = useState(true);
  const [isAllowRepeatInBasket, setIsAllowRepeatInBasket] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [isAllowRepeatInBasketInitial, setIsAllowRepeatInBasketInitial] =
    useState(true);
  const [availabilitySelectionList, setAvailabilitySelectionList] =
    useState<any>([]);
  const [
    availabilitySelectionListInitial,
    setAvailabilitySelectionListInitial,
  ] = useState<any>([]);
  const [isSwitchActive, setIsSwitchActive] = useState(true);
  const [isActiveInitial, setIsActiveInitial] = useState(true);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [isDeliveryTypeEmpty, setIsDeliveryTypeEmpty] = useState(false);
  const [isOfferTypeEmpty, setIsOfferTypeEmpty] = useState(false);
  const [isLoadingButton, setIsLoadingButton] = useState(false);
  const [isOpenProductsAddModal, setIsOpenProductsAddModal] = useState(false);
  const [isApplyToEmpty, setIsApplyToEmpty] = useState(false);
  const [isPlatformEmpty, setIsPlatformEmpty] = useState(false);
  const [isMembersEmpty, setIsMembersEmpty] = useState(false);

  const [availabilityErrorMessage, setAvailabilityErrorMessage] =
    useState(false);
  const [success, setSuccess] = useState("");
  const [selectedOfferType, setSelectedOfferType] = useState<any>({});
  const [selectedOfferTypeInitial, setSelectedOfferTypeInitial] = useState<any>(
    {},
  );
  const [editableRewardId, setEditableRewardId] = useState<any>([]);
  const [selectedPriorityType, setSelectedPriorityType] = useState<any>([]);
  const [selectedPriorityTypeInitial, setSelectedPriorityTypeInitial] =
    useState<any>([]);
  const [selectedProducts, setSelectedProducts] = useState<any>([]);
  const [selectedUsageLimitType, setSelectedUsageLimitType] = useState<any>({
    id: "Global",
    label: "GLOBAL",
  });
  const [selectedPlatform, setSelectedPlatform] = useState<any>([]);
  const [selectedPlatformInitial, setSelectedPlatformInitial] = useState<any>(
    [],
  );
  const [selectedDiscountMethod, setSelectedDiscountMethod] = useState<any>({});
  const [selectedDiscountMethodInitial, setSelectedDiscountMethodInitial] =
    useState<any>({});
  const [isSelectedMethodEmpty, setIsSelectedMethodEmpty] = useState<any>();
  const [isOpenSuccessModal, setIsOpenSuccessModal] = useState(false);
  const [selectedApplyTo, setSelectedApplyTo] = useState<any>({
    id: "CHEAPEST",
    label: "Cheapest",
  });
  const [selectedApplyToInitial, setSelectedApplyToInitial] = useState<any>({
    id: "CHEAPEST",
    label: "Cheapest",
  });
  const [offerItemMapInitial, setOfferItemMapInitial] = useState<any>({});
  const [fromDate, setFromDate] = useState(
    moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
  );
  const [fromDateInitial, setFromDateInitial] = useState(
    moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
  );
  const [toDate, setToDate] = useState(
    moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
  );
  const [toDateInitial, setToDateInitial] = useState(
    moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
  );
  // const abc = {
  //   "availability": [],
  //   "deliveryTypes": ["dinein", "takeout", "delivery"],
  //   "description": "12",
  //   "endAt": null,
  //   "groups": [
  //     {
  //       "groupIndex": 0,
  //       "name": "test offer 2",
  //       "requiredPick": "12",
  //       "minPriceEach": null,
  //       "maxPriceEach": null,
  //       "members": [{ "memberType": "ITEM", "memberId": 1943 }],
  //     },
  //   ],
  //   "id": "5c686e5e-036c-4d37-935a-3262fe7fd071",
  //   "isActive": true,
  //   "locationId": "7713dce7-51ec-4870-b251-4bce1c9249f8",
  //   "minOrderPrice": "0.00",
  //   "name": "test offer 2",
  //   "offerType": "BUY_X_GET_Y_CHEAPEST_DISCOUNTED",
  //   "platforms": ["online"],
  //   "priority": 50,
  //   "rewards": [
  //     {
  //       "rewardType": "DISCOUNT_CHEAPEST_ITEMS",
  //       "discountMethod": "FIXED",
  //       "discountValue": "12.00",
  //       "allowRepeatInBasket": true,
  //       "applyTo": "CHEAPEST",
  //       "discountedQuantity": "11",
  //       "fixedTotalPrice": 0,
  //     },
  //   ],
  //   "startAt": null,
  //   "usageLimitType": "GLOBAL",
  // };
  const [originalNodeData, setOriginalNodeData] = useState({
    availability: [],
    isActive: false,
    minOrderPrice: "0",
    name: "",
    description: "",
    UsageLimitType: "",
    usageLimit: 0,
    deliveryTypes: [],
    id: "",
    startAt: null as string | null, // <-- The fix is here
    endAt: null as string | null, // <-- And here
    locationId: "",
    platforms: [],
    offerType: "",
    priority: 50,
    groups: [
      {
        groupIndex: 0,
        name: "",
        requiredPick: 1,
        minPriceEach: null,
        maxPriceEach: null,
        members: [
          {
            memberType: "CATEGORY",
            memberId: "188",
          },
        ],
      },
    ],
    rewards: [
      {
        rewardType: "",
        discountedQuantity: 1,
        discountMethod: "",
        discountValue: 0,
        applyTo: "",
        allowRepeatInBasket: true,
        fixedTotalPrice: 1,
      },
    ],
  });

  const handleSelectProduct = (
    event: Event,
    productWrapper: any,
    item: { id: string; name: string },
  ) => {
    const cloneSelectedWrapperIdList = { ...selectedWrapperIdList };

    // Step 1: Check and remove from undefined section if it exists
    if (cloneSelectedWrapperIdList.undefined?.[item.id]) {
      delete cloneSelectedWrapperIdList.undefined[item.id];

      if (Object.keys(cloneSelectedWrapperIdList.undefined).length === 0) {
        delete cloneSelectedWrapperIdList.undefined;
      }

      const output = Object.entries(offerItemMap).reduce(
        (acc: any, [key, value]: any) => {
          const newObj = { ...value };
          newObj.offerNameList = [...(value.offerNameList || [])];

          // if key equals selected id → increase activeCount by 1 (example logic)
          if (key === item.id) {
            if (isActive) {
              newObj.activeCount = (value.activeCount || 0) - 1;
            } else {
              newObj.deActiveCount = (value.deActiveCount || 0) - 1;
            }
            newObj.offerNameList = newObj.offerNameList.filter(
              (name: string) => name !== offerName,
            );
          }

          acc[key] = newObj;
          return acc;
        },
        {},
      );
      setOfferItemMap(output);
      // Stop here — do not add the item anywhere else
      setSelectedWrapperIdList(cloneSelectedWrapperIdList);
      return;
    }

    // Step 2: Toggle item in the actual productWrapper.id section
    if (cloneSelectedWrapperIdList[productWrapper.id]?.[item.id]) {
      delete cloneSelectedWrapperIdList[productWrapper.id][item.id];

      if (
        Object.keys(cloneSelectedWrapperIdList[productWrapper.id]).length === 0
      ) {
        delete cloneSelectedWrapperIdList[productWrapper.id];
        const output = Object.entries(offerItemMap).reduce(
          (acc: any, [key, value]: any) => {
            const newObj = { ...value };
            newObj.offerNameList = [...(value.offerNameList || [])];

            // if key equals selected id → increase activeCount by 1 (example logic)
            if (key === item.id) {
              if (isActive) {
                newObj.activeCount = (value.activeCount || 0) - 1;
              } else {
                newObj.deActiveCount = (value.deActiveCount || 0) - 1;
              }
              newObj.offerNameList = newObj.offerNameList.filter(
                (name: string) => name !== offerName,
              );
            }

            acc[key] = newObj;
            return acc;
          },
          {},
        );
        setOfferItemMap(output);
      }
    } else {
      if (!cloneSelectedWrapperIdList[productWrapper.id]) {
        cloneSelectedWrapperIdList[productWrapper.id] = {};
      }
      cloneSelectedWrapperIdList[productWrapper.id][item.id] = {
        memberId: item.id,
        wrapperId: productWrapper.id,
        name: item.name,
        img: productWrapper.img,
        memberType: "ITEM",
      };

      const output = Object.entries(offerItemMap).reduce(
        (acc: any, [key, value]: any) => {
          const newObj = { ...value };

          // Ensure offerNameList exists
          newObj.offerNameList = [...(value.offerNameList || [])];

          if (key === String(item.id)) {
            if (isActive) {
              // 🔵 When activating: increase activeCount and add offer name
              newObj.activeCount = (value.activeCount || 0) + 1;
            } else {
              // 🔴 When deactivating: increase deActiveCount and remove offer name if exists
              newObj.deActiveCount = (value.deActiveCount || 0) + 1;
            }
            if (!newObj.offerNameList.includes(offerName)) {
              newObj.offerNameList.push(offerName);
            }
          }

          acc[key] = newObj;
          return acc;
        },
        {},
      );

      setOfferItemMap(output);
    }

    setSelectedWrapperIdList(cloneSelectedWrapperIdList);
  };
  function capitalizeFirstLetter(str: string): string {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }
  /* Use a react form hooks */
  const { register, handleSubmit, errors, reset, formState, clearErrors } =
    useForm<FormData>({
      defaultValues: {
        name: "",
        description: "",
        value: "",
        minOrderPrice: "",
        usageLimit: 0,
        discountGroup: "",
        deliveryTypes: [],
        discountCode: "",
        discountedQuantity: 1,
        requiredPick: 1,
      },
    });

  // Check the form edit or not using react form hook.
  const isFormEdited = formState.isDirty;
  const match: any = useRouteMatch();

  /* Get updated data after changes. */
  const getNodeDataByState = (data: any) => {
    const updatedData = _.cloneDeep(originalNodeData);
    const abc: any = [];
    selectedPlatform.forEach((item: any) => {
      abc.push(item.id);
    });
    updatedData.availability = availabilitySelectionList;
    updatedData.isActive = isActive;
    updatedData.minOrderPrice = convertDecimalPoint(
      data.minOrderPrice,
    ).toString();
    updatedData.offerType = selectedOfferType.id;
    updatedData.priority = selectedPriorityType.id;
    updatedData.platforms = abc;
    updatedData.name = data.name;
    updatedData.description = data.description;
    updatedData.startAt = isSwitchActive ? fromDate.replace(" ", "T") : null;
    updatedData.endAt = isSwitchActive ? toDate.replace(" ", "T") : null;
    updatedData.usageLimit = data.usageLimit;
    updatedData.deliveryTypes = deliveryTypesList;
    // updatedData.groups = data.requiredPick;

    if (
      selectedOfferType.id === "BUY_X_GET_Y_CHEAPEST_DISCOUNTED" ||
      selectedOfferType.id === "FIXED_PRICE_FOR_X_ITEMS"
    ) {
      const selectedProductsUpdate = Object.values(
        selectedWrapperIdList,
      ).flatMap((innerObj: any) =>
        Object.values(innerObj).map(({ memberType, memberId }: any) => ({
          memberType,
          memberId: Number(memberId),
        })),
      );
      const obj: any = {
        groupIndex: 0,
        name: data.name,
        requiredPick: data.requiredPick,
        minPriceEach: null,
        maxPriceEach: null,
        members: selectedProductsUpdate,
      };
      updatedData.groups = [obj];
    } else {
      updatedData.groups = groupInfo;
    }
    let rewards: any = {};

    if (selectedOfferType.id === "BUY_X_GET_Y_CHEAPEST_DISCOUNTED") {
      rewards["rewardType"] = "DISCOUNT_CHEAPEST_ITEMS";
      rewards["discountMethod"] = selectedDiscountMethod?.id;
      rewards["discountValue"] =
        selectedDiscountMethod.id === "FREE" ? 0 : data.discountValue;
      rewards["fixedTotalPrice"] = 0;
    } else {
      rewards["rewardType"] = "FIXED_PRICE_BUNDLE";
      rewards["discountMethod"] = "FIXED";
      rewards["discountValue"] = 0;
      rewards["fixedTotalPrice"] = data.fixedTotalPrice;
    }
    rewards["discountedQuantity"] = data.discountedQuantity;
    rewards["applyTo"] = selectedApplyTo?.id;
    rewards["allowRepeatInBasket"] = isAllowRepeatInBasket;
    updatedData.rewards = [rewards];

    return updatedData;
  };

  useEffect(() => {
    if (Object.values(nodeData).length > 0) {
      const { groups } = nodeData;
      const output = groups[0].members.reduce((acc: any, member: any) => {
        const { menuId, memberId } = member;
        if (!acc[menuId]) acc[menuId] = {};
        acc[menuId][memberId] = { ...member };
        return acc;
      }, {});
      setSelectedWrapperIdListInitialNew(output);
    }
  }, [nodeData]);

  /* Update states after creating delete or update banner information. */
  const setNodeDataToState = useCallback((nodeValues) => {
    const {
      id,
      isActive,
      minOrderPrice,
      name,
      description,
      value,
      usageLimit,
      discountGroup,
      discountCode,
      deliveryTypes,
      availability,
      offerType,
      priority,
      startAt,
      endAt,
      platforms,
      groups,
      rewards,
    } = nodeValues;

    setOfferItemMapInitial(offerItemMap);
    offerTypeList.map((item: any) => {
      if (item.id === offerType) {
        setSelectedOfferType({ id: item.id, label: item.label });
        setSelectedOfferTypeInitial({ id: item.id, label: item.label });
      }
    });
    const platform: any = [];

    platformList.map((item: any) => {
      if (platforms.includes(item.id)) {
        platform.push({ id: item.id, label: item.label });
      }
    });

    setSelectedPlatform(platform);
    setSelectedPlatformInitial(platform);
    // usageList.map((item: any) => {
    //   if (item.id === usageLimitType) {
    //     setSelectedUsageLimitType({ id: item.id, label: item.label });
    //   }
    // });
    setFromDate(
      startAt
        ? startAt.replace("T", " ")
        : moment().format("YYYY-MM-DD HH:mm:ss"),
    );
    setFromDateInitial(
      startAt
        ? startAt.replace("T", " ")
        : moment().format("YYYY-MM-DD HH:mm:ss"),
    );
    setToDate(
      endAt ? endAt.replace("T", " ") : moment().format("YYYY-MM-DD HH:mm:ss"),
    );
    setToDateInitial(
      endAt ? endAt.replace("T", " ") : moment().format("YYYY-MM-DD HH:mm:ss"),
    );
    if (startAt && endAt) {
      setIsSwitchActive(true);
    } else {
      setIsSwitchActive(false);
    }
    setSelectedPriorityType({ id: priority, label: priority.toString() });
    setSelectedPriorityTypeInitial({
      id: priority,
      label: priority.toString(),
    });
    setDeliveryTypesList(deliveryTypes);
    setDeliveryTypesListInitial(deliveryTypes);
    setIsActive(isActive);
    setIsActiveInitial(isActive);

    if (
      offerType === "BUY_X_GET_Y_CHEAPEST_DISCOUNTED" ||
      offerType === "FIXED_PRICE_FOR_X_ITEMS"
    ) {
      const output = groups[0].members.reduce((acc: any, member: any) => {
        const { menuId, memberId } = member;
        if (!acc[menuId]) acc[menuId] = {};
        acc[menuId][memberId] = { ...member };
        return acc;
      }, {});
      setSelectedWrapperIdList(output);
    } else {
      setGroupInfo(groups);
      setGroupInfoInitial(groups);
    }
    setAvailabilitySelectionList(availability);
    setAvailabilitySelectionListInitial(availability);

    const {
      discountValue,
      fixedTotalPrice,
      discountMethod,
      discountedQuantity,
      applyTo,
      allowRepeatInBasket,
    } = rewards[0];
    setSelectedDiscountMethod({
      id: discountMethod,
      label: capitalizeFirstLetter(discountMethod),
    });
    setSelectedDiscountMethodInitial({
      id: discountMethod,
      label: capitalizeFirstLetter(discountMethod),
    });
    setSelectedApplyTo({ id: applyTo, label: capitalizeFirstLetter(applyTo) });
    setSelectedApplyToInitial({
      id: applyTo,
      label: capitalizeFirstLetter(applyTo),
    });
    setIsAllowRepeatInBasket(allowRepeatInBasket);
    setIsAllowRepeatInBasketInitial(allowRepeatInBasket);
    // rewards["discountedQuantity"] = data.discountedQuantity;
    // rewards["applyTo"] = selectedApplyTo?.id;
    // rewards["allowRepeatInBasket"] = isAllowRepeatInBasket;
    // updatedData.rewards = [rewards];
    // Changing the value of the text field according to the response.
    reset({
      name,
      description,
      value,
      minOrderPrice,
      usageLimit: usageLimit.toString(),
      discountGroup,
      deliveryTypes,
      discountCode,
      requiredPick:
        offerType === "BUY_X_GET_Y_CHEAPEST_DISCOUNTED" ||
        offerType === "FIXED_PRICE_FOR_X_ITEMS"
          ? groups[0].requiredPick
          : 0,
      discountValue:
        discountMethod === "PERCENTAGE"
          ? parseFloat(discountValue).toFixed(0)
          : discountValue,
      fixedTotalPrice,
      discountedQuantity,
    });
  }, []);
  useEffect(() => {
    setOriginalNodeData(nodeData);
    setNodeDataToState(nodeData);
  }, [nodeData, setNodeDataToState]);
  const compareNestedObjects = (obj1: any, obj2: any) => {
    // Convert top-level objects to arrays of their nested key sets
    const getNestedKeySets = (obj: any) =>
      Object.values(obj).map((nested: any) => new Set(Object.keys(nested)));

    const nestedKeys1 = getNestedKeySets(obj1);
    const nestedKeys2 = getNestedKeySets(obj2);

    if (nestedKeys1.length !== nestedKeys2.length) return false;

    // Compare each nested set
    for (let i = 0; i < nestedKeys1.length; i++) {
      const set1 = nestedKeys1[i];
      const set2 = nestedKeys2[i];
      if (set1.size !== set2.size) return false;

      for (let key of set1) {
        if (!set2.has(key)) return false;
      }
    }

    return true;
  };
  /* Enable or disable Create/Edit button. */
  useEffect(() => {
    // Enables the create/edit button if any changes are not made to the form.
    const clone = { ...selectedWrapperIdListInitial };
    if (
      !isFormEdited &&
      isActive === isActiveInitial &&
      listsAreEqual(deliveryTypesList, deliveryTypesListInitial) &&
      // areObjectArraysEqual(
      //   selectedWrapperIdList,
      //   selectedWrapperIdListInitial,
      // ) &&
      isAllowRepeatInBasket === isAllowRepeatInBasketInitial &&
      listsAreEqual(
        availabilitySelectionList,
        availabilitySelectionListInitial,
      ) &&
      listsAreEqual(selectedPlatform, selectedPlatformInitial) &&
      compareNestedObjects(groupInfo, groupInfoInitial) &&
      selectedOfferType?.id === selectedOfferTypeInitial?.id &&
      selectedPriorityType?.id === selectedPriorityTypeInitial?.id &&
      selectedPlatform?.id === selectedPlatformInitial?.id &&
      selectedDiscountMethod?.id === selectedDiscountMethodInitial?.id &&
      selectedApplyTo?.id === selectedApplyToInitial?.id &&
      compareNestedObjects(clone, selectedWrapperIdList) &&
      moment(fromDate).format("YYYY-MM-DD") ===
        moment(fromDateInitial).format("YYYY-MM-DD") &&
      moment(toDate).format("YYYY-MM-DD") ===
        moment(toDateInitial).format("YYYY-MM-DD")
    ) {
      setButtonDisabled(true);
    } else {
      // Enables the create/edit button if any changes are made to the form.
      setButtonDisabled(false);
    }
  }, [
    isFormEdited,
    isActive,
    isActiveInitial,
    deliveryTypesList,
    deliveryTypesListInitial,
    selectedWrapperIdList,
    isAllowRepeatInBasket,
    groupInfo,
    groupInfoInitial,
    isAllowRepeatInBasketInitial,
    availabilitySelectionList,
    availabilitySelectionListInitial,
    selectedOfferType,
    selectedOfferTypeInitial,
    selectedPriorityType,
    selectedPriorityTypeInitial,
    selectedPlatform,
    selectedPlatformInitial,
    selectedDiscountMethod,
    selectedDiscountMethodInitial,
    selectedApplyTo,
    selectedApplyToInitial,
    fromDate,
    fromDateInitial,
    toDate,
    toDateInitial,
  ]);
  /* Update the deliveryTypeList after selecting the delivery options using switches (dine-in, takeout, and delivery). */
  const handleSelectDeliveryTypes = (e: any) => {
    const { value, name, checked } = e.target;
    setIsDeliveryTypeEmpty(false);
    // When a delivery type option is selected, that delivery type option is entered into a list.
    if (checked) {
      const selectedList: any = new Set([...deliveryTypesList, value]);
      setDeliveryTypesList([...selectedList]);
    } else {
      // When a delivery type option is not selected, that delivery type option is removed into a list.
      const selectedList: any = deliveryTypesList.filter(
        (amountType: String) => name !== amountType,
      );
      setDeliveryTypesList(selectedList);
    }
  };

  const [finalData, setFinalData] = useState({});
  const [finalBody, setFinalBody] = useState({});
  /* Send an API call to crete discount information after click create button. */
  const handleCreateOfferOption = async (data: any) => {
    setIsLoading(true);
    setError("");
    const createData: any = getNodeDataByState(data);
    delete createData.status;
    let message = "";
    message = "Eatpresto Discount Information Changed";

    const summary = {
      Active: data.active ? "Active" : "Inactive",
      "Discount Group": data.discountGroup,
      "Min Order Price": data.minOrderPrice,
      Name: data.name,
      Description: data.description,
      "usage Limit": data.usageLimit,
      "Payment Types": data.paymentTypes,
    };
    const body = {
      message,
      summary: `Discount Information changed from ${JSON.stringify(
        [],
      )} to ${JSON.stringify([cleanObject(summary)])}`,
      code: "create",
      access_type: true,
      metadata: { changedBy: "" },
    };
    setFinalData(createData);
    setFinalBody(body);
    setIsOpenSuccessModal(true);
    // await updateOfferInfo(
    //   match.params.locationId,
    //   createData,
    //   nodeData.id,
    //   body,
    //   "eatpresto",
    // )
    //   .then((res) => {
    //     getOfferInfo();
    //     setSuccess(SUCCESSFULLY_UPDATED);
    //     setIsLoading(false);
    //   })
    //   .catch((err) => {
    //     if (err.response.status === HttpStatus.CONFLICT_409) {
    //       setError(ERROR_MESSAGE_VERSION_ERROR);
    //       getOfferInfo();
    //     } else {
    //       setError(ERROR_MESSAGE_CREATING_ERROR);
    //     }
    //     setIsLoading(true);
    //   });
  };

  /* Check for a create or update and 
  call the handleCreateOfferOption function if it is a create and 
  handleUpdateDiscountInfo function if it is a update. */
  const handleSubmitData = handleSubmit((data) => {
    setError("");

    // 1. Reset all previous validation errors at the start of the submission.
    setIsDeliveryTypeEmpty(false);
    setIsOfferTypeEmpty(false);
    setIsSelectedMethodEmpty(false);
    setIsApplyToEmpty(false);
    setIsPlatformEmpty(false);
    setIsMembersEmpty(false);
    // 2. Use a flag to track if the form is valid.
    let isFormValid = true;

    // --- Validation Checks ---

    // Check for Delivery Types
    if (_.isEmpty(deliveryTypesList)) {
      setIsDeliveryTypeEmpty(true);
      isFormValid = false;
    }

    // Check for Offer Type
    if (!selectedOfferType?.id) {
      setIsOfferTypeEmpty(true);
      isFormValid = false;
    }

    // Check for "Apply To"
    if (!selectedApplyTo?.id) {
      setIsApplyToEmpty(true);
      isFormValid = false;
    }

    if (selectedPlatform.length === 0) {
      setIsPlatformEmpty(true);
      isFormValid = false;
    }
    if (
      selectedOfferType?.id !== "FIXED_PRICE_FROM_X_LISTS" &&
      Object.keys(selectedWrapperIdList).length === 0
    ) {
      setIsMembersEmpty(true);
      isFormValid = false;
    }

    if (
      selectedOfferType?.id === "FIXED_PRICE_FROM_X_LISTS" &&
      Object.keys(groupInfo).length < 2
    ) {
      setIsMembersEmpty(true);
      isFormValid = false;
    }

    // Conditionally check for Discount Method only if the offer type requires it
    if (
      selectedOfferType?.id === "BUY_X_GET_Y_CHEAPEST_DISCOUNTED" &&
      !selectedDiscountMethod?.id
    ) {
      setIsSelectedMethodEmpty(true);
      isFormValid = false;
    }
    // 3. If after all checks the form is still valid, proceed with submission.
    if (!isFormValid) {
      return; // Stop the submission if any validation failed
    }
    // --- Submission Logic ---

    setAvailabilityErrorMessage(false); // Clear other potential errors

    handleCreateOfferOption(data);
  });

  /* Send an API call to after click availability apply button. 
  An API call is sent only if the status is not "create". */
  const handleSubmitAvailability = async (
    availabilitySelectionList: Array<any>,
  ) => {
    const combinedMowArrays: any = combineMinuteOfWeekArrays(
      availabilitySelectionList,
    );
    let normalizedArray = _.cloneDeep(combinedMowArrays);

    // Remove select same date range in same same date.
    Object.keys(combinedMowArrays).forEach((day) => {
      normalizedArray[day] = normalizeTimeSelections(normalizedArray[day]);
    });

    // Convert array to minute of week array
    const mowArray: any = Object.values(normalizedArray).flat();

    // Update data
    setAvailabilitySelectionList(mowArray);
  };

  /* Active switch status change using switch */
  const handleSwitchActivate = (e: any) => {
    const { checked } = e.target;
    setIsActive(checked);

    const updatedOfferItemMap = updateOfferStatus(checked);
    setOfferItemMap(updatedOfferItemMap);
  };

  const handleAllowRepeatInBasketActivate = (e: any) => {
    const { checked } = e.target;
    setIsAllowRepeatInBasket(checked);
  };

  const updateOfferStatus = (checked: boolean) => {
    const output: any = {};

    Object.entries(offerItemMap).forEach(([key, value]: any) => {
      // copy old data
      output[key] = { ...value };
      // check if this idList includes the offer
      if (value.idList.includes(nodeData.id)) {
        if (checked) {
          // ✅ activating: decrease deActive, increase active
          output[key].activeCount = Math.min(
            value.activeCount + 1,
            value.idList.length,
          );
          output[key].deActiveCount = Math.max(value.deActiveCount - 1, 0);
        } else {
          // ❌ deactivating: decrease active, increase deActive
          output[key].activeCount = Math.max(value.activeCount - 1, 0);
          output[key].deActiveCount = value.deActiveCount + 1;
        }
      }
    });

    return output;
  };

  const handleSelectSwitchActivate = (e: any) => {
    const { checked } = e.target;
    setIsSwitchActive(checked);
    if (!checked) {
      setFromDate(moment(new Date()).format("YYYY-MM-DD HH:mm:ss"));
      setToDate(moment(new Date()).format("YYYY-MM-DD HH:mm:ss"));
    }
  };

  const handleChangeOfferType = (e: any, offerType: any) => {
    if (offerType.id !== "BUY_X_GET_Y_CHEAPEST_DISCOUNTED") {
      setSelectedDiscountMethod({ id: "FIXED", label: "Fixed" });
    }
    if (offerType?.id === "FIXED_PRICE_FOR_X_ITEMS" || offerType?.id === "FIXED_PRICE_FROM_X_LISTS") {
      handleChangeApplyTo(null, { id: "CHEAPEST", label: "Cheapest" });
    }
    setIsOfferTypeEmpty(false);
    setSelectedOfferType(offerType);
    setSelectedApplyTo(selectedApplyToInitial);
    setSelectedDiscountMethod(selectedDiscountMethodInitial);
  };

  const handleChangePriorityType = (e: any, priorityType: any) => {
    setSelectedPriorityType(priorityType);
  };

  const handleChangeUsageLimitType = (e: any, priorityType: any) => {
    setSelectedPriorityType(priorityType);
  };

  const handleChangePlatform = (e: any, applyTo: any) => {
    setSelectedPlatform(applyTo);
  };

  const handleChangeDiscountMethod = (e: any, discountMethod: any) => {
    setSelectedDiscountMethod(discountMethod);
    setIsSelectedMethodEmpty(false);
  };

  const handleChangeApplyTo = (e: any, priorityType: any) => {
    setSelectedApplyTo(priorityType);
  };

  const handleChangeFromDate = (date: any) => {
    setFromDate(moment(date).format("YYYY-MM-DD HH:mm:ss"));
  };

  const handleChangeToDate = (date: any) => {
    setToDate(moment(date).format("YYYY-MM-DD HH:mm:ss"));
  };

  const handleOpenProductsAddModal = () => {
    setIsOpenProductsAddModal(true);
  };

  const handleCloseSuccessModal = async () => {
    // Set 'isOpenSuccessModal' state to false to hide the success modal.
    await updateOfferInfo(
      match.params.locationId,
      finalData,
      nodeData.id,
      finalBody,
      "eatpresto",
    )
      .then((res) => {
        getOfferInfo();
        setSuccess(SUCCESSFULLY_CREATED);
        setOpenDialog(false);
        setIsOpenSuccessModal(true);
      })
      .catch((err) => {
        if (err.response.status === HttpStatus.CONFLICT_409) {
          setError(ERROR_MESSAGE_VERSION_ERROR);
          getOfferInfo();
          setIsOpenSuccessModal(false);
        } else {
          setError(ERROR_MESSAGE_CREATING_ERROR);
        }
      });
    setIsOpenSuccessModal(false);
  };

  const handleSubmitRewards = (
    selectedWrapperIdList: any,
    isEdit: any,
    rewardId: any,
  ) => {
    setSelectedProducts(selectedWrapperIdList);
    setIsMembersEmpty(false);
    setIsOpenProductsAddModal(false);
  };

  const classes = useStyles();
  const theme: CustomTheme = useTheme();
  return (
    <>
      <DialogCommonDefault
        open={openDialog}
        setOpen={() => setOpenDialog(false)}
        isNeedFixedHeight={false}
      >
        <DialogTitle>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Typography variant="h5">Edit Offers</Typography>
            <Button onClick={() => setOpenDialog(false)}>
              <CloseIcon />
            </Button>
          </div>
        </DialogTitle>
        <DialogContent>
          <Grid>
            <DefaultAlert
              open={!!success}
              handleClose={() => setSuccess("")}
              message={success}
              severity={"success"}
            />
            {error && (
              <Typography
                component="div"
                className={classes.error}
                variant="body1"
              >
                {error}
              </Typography>
            )}
            <Grid container spacing={2}>
              <Grid
                container
                spacing={2}
                xs={6}
                style={{
                  placeItems: "center",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <FormControlLabel
                  control={<SwitchCommon />}
                  checked={isActive}
                  onChange={handleSwitchActivate}
                  label={
                    <Typography variant="caption" color="textSecondary">
                      Active
                    </Typography>
                  }
                  labelPlacement="bottom"
                />
                {/* <FormControlLabel
                style={{ marginLeft: "0px", marginRight: "0px" }}
                control={<SwitchCommon />}
                checked={isSwitchActive}
                onChange={handleSelectSwitchActivate}
                label="Select"
                labelPlacement="start"
                disabled={!isAuthorized}
              /> */}
              </Grid>
              <Grid item xs={6}>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <FormControlLabel
                    style={{ marginLeft: "0px", marginRight: "0px" }}
                    value="dinein"
                    control={<SwitchCommon />}
                    label={
                      <Typography variant="caption" color="textSecondary">
                        Dine In
                      </Typography>
                    }
                    name="dinein"
                    checked={
                      !_.isEmpty(deliveryTypesList)
                        ? deliveryTypesList.includes(DeliveryTpe.DINEIN)
                        : false
                    }
                    labelPlacement="bottom"
                    onChange={handleSelectDeliveryTypes}
                  />
                  <FormControlLabel
                    style={{ marginLeft: "0px", marginRight: "0px" }}
                    value="delivery"
                    control={<SwitchCommon />}
                    label={
                      <Typography variant="caption" color="textSecondary">
                        Delivery
                      </Typography>
                    }
                    name="delivery"
                    checked={
                      !_.isEmpty(deliveryTypesList)
                        ? deliveryTypesList.includes(DeliveryTpe.DELIVERY)
                        : false
                    }
                    labelPlacement="bottom"
                    onChange={handleSelectDeliveryTypes}
                  />
                  <FormControlLabel
                    style={{ marginLeft: "0px", marginRight: "0px" }}
                    value="takeout"
                    name="takeout"
                    control={<SwitchCommon />}
                    label={
                      <Typography variant="caption" color="textSecondary">
                        Takeout
                      </Typography>
                    }
                    checked={
                      !_.isEmpty(deliveryTypesList)
                        ? deliveryTypesList.includes(DeliveryTpe.TAKEOUT)
                        : false
                    }
                    labelPlacement="bottom"
                    onChange={handleSelectDeliveryTypes}
                  />
                </div>
                {_.isEqual(isDeliveryTypeEmpty, true) && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "start",
                      marginBottom: "3px",
                    }}
                  >
                    <Typography
                      align="left"
                      variant="caption"
                      style={{ color: "red" }}
                    >
                      Please select a least one delivery option.
                    </Typography>
                  </div>
                )}
              </Grid>
            </Grid>
            <Divider variant="fullWidth" style={{ margin: "4px 0 8px 0" }} />

            <Grid container spacing={2}>
              <Grid item xs={12} style={{ marginTop: "8px" }}>
                <Typography variant="body2" style={{ fontWeight: "bold" }}>
                  Name
                </Typography>
                <TextfieldDefault
                  id="name"
                  name="name"
                  type="text"
                  label=""
                  style={{
                    border: `1px solid ${theme.palette.background.entity_border}`,
                  }}
                  inputRef={register({
                    required: "Name is required",
                    minLength: {
                      value: 2,
                      message: "Minimum Character is 2",
                    },
                    maxLength: {
                      value: 30,
                      message: "Maximum Character is 30",
                    },
                  })}
                />
                {errors.name ? (
                  <ValidationMessage message={errors.name.message} />
                ) : (
                  ""
                )}
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body2" style={{ fontWeight: "bold" }}>
                  Description
                </Typography>
                <TextfieldDefault
                  id="description"
                  name="description"
                  type="text"
                  label=""
                  multiline={true}
                  rows={4}
                  style={{
                    border: `1px solid ${theme.palette.background.entity_border}`,
                  }}
                  inputRef={register({
                    minLength: {
                      value: 2,
                      message: "Minimum Character is 2",
                    },
                  })}
                />
                {errors.description ? (
                  <ValidationMessage message={errors.description.message} />
                ) : (
                  ""
                )}
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body2" style={{ fontWeight: "bold" }}>
                  Offer Type
                </Typography>

                <Autocomplete
                  open={isOpenCriticalType}
                  onOpen={() => setIsOpenCriticalType(true)}
                  onClose={() => setIsOpenCriticalType(false)}
                  size="small"
                  id="offerTypeSelect"
                  color="inherit"
                  options={offerTypeList}
                  value={selectedOfferType}
                  getOptionLabel={(option: any) => option.label || ""}
                  disableClearable
                  onChange={handleChangeOfferType}
                  classes={{ root: classes.autoComplete }}
                  popupIcon={<ArrowDropDownIcon color="inherit" />}
                  renderOption={(option) => (
                    <Grid container direction="column">
                      <Typography
                        variant="body2"
                        className={classes.titleColor}
                      >
                        {option.label}
                      </Typography>
                      <Typography
                        variant="caption"
                        color="textSecondary"
                        style={{
                          marginTop: 2,
                          color: theme.palette.custom.orange.contrastText,
                        }}
                      >
                        {option.desc}
                      </Typography>
                    </Grid>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label=""
                      placeholder=""
                      variant="outlined"
                    />
                  )}
                />
                {_.isEqual(isOfferTypeEmpty, true) && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "start",
                      marginBottom: "3px",
                    }}
                  >
                    <Typography
                      align="left"
                      variant="caption"
                      style={{ color: "red" }}
                    >
                      Please select a Offer.
                    </Typography>
                  </div>
                )}
              </Grid>
              {/* <Grid item xs={6}>
                <Typography
                  variant="body2"
                  style={{ fontWeight: "bold", marginBottom: "10px" }}
                >
                  Priority
                </Typography>
                <Autocomplete
                  open={isOpenPriority}
                  onOpen={() => setIsOpenPriority(true)}
                  onClose={() => setIsOpenPriority(false)}
                  size={"small"}
                  id="locationSelectGlobal"
                  color="inherit"
                  options={priorityList}
                  value={selectedPriorityType}
                  getOptionLabel={(option: any) => option.label || ""}
                  disableClearable
                  onChange={handleChangePriorityType}
                  classes={{ root: classes.autoComplete }}
                  popupIcon={<ArrowDropDownIcon color={"inherit"} />}
                  renderOption={(props: any) => {
                    return (
                      <Grid
                        container
                        {...props}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          zIndex: 0,
                          height: "20px",
                          marginBottom: "4px",
                        }}
                      >
                        <Grid item xs={12}>
                          <Typography
                            variant="body2"
                            className={classes.titleColor}
                          >
                            {props.label}
                          </Typography>
                        </Grid>
                      </Grid>
                    );
                  }}
                  renderInput={(params: any) => (
                    <TextField
                      color="inherit"
                      {...params}
                      label=""
                      placeholder=""
                      variant="outlined"
                    />
                  )}
                />
              </Grid> */}
              <Grid item xs={6}>
                <Typography variant="body2" style={{ fontWeight: "bold" }}>
                  Min Order Price
                </Typography>
                <TextfieldDefault
                  id="minOrderPrice"
                  name="minOrderPrice"
                  type="number"
                  label=""
                  style={{
                    border: `1px solid ${theme.palette.background.entity_border}`,
                  }}
                  inputRef={register({
                    required: "Min Order Price is required",
                  })}
                />
                {errors.minOrderPrice ? (
                  <ValidationMessage message={errors.minOrderPrice.message} />
                ) : (
                  ""
                )}
              </Grid>
              {/* <Grid item xs={6}>
                <Typography
                  variant="body2"
                  style={{ fontWeight: "bold", marginBottom: "10px" }}
                >
                  Usage Limit Type
                </Typography>
                <Autocomplete
                  open={isOpenUsageLimitType}
                  onOpen={() => setIsOpenUsageLimitType(true)}
                  onClose={() => setIsOpenUsageLimitType(false)}
                  size={"small"}
                  id="locationSelectGlobal"
                  color="inherit"
                  options={usageList}
                  value={selectedUsageLimitType}
                  getOptionLabel={(option: any) => option.label || ""}
                  disableClearable
                  disabled={true}
                  onChange={handleChangeUsageLimitType}
                  classes={{ root: classes.autoComplete }}
                  popupIcon={<ArrowDropDownIcon color={"inherit"} />}
                  renderOption={(props: any) => {
                    return (
                      <Grid
                        container
                        {...props}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          zIndex: 0,
                          height: "20px",
                          marginBottom: "4px",
                        }}
                      >
                        <Grid item xs={12}>
                          <Typography
                            variant="body2"
                            className={classes.titleColor}
                          >
                            {props.label}
                          </Typography>
                        </Grid>
                      </Grid>
                    );
                  }}
                  renderInput={(params: any) => (
                    <TextField
                      color="inherit"
                      {...params}
                      label=""
                      placeholder=""
                      variant="outlined"
                    />
                  )}
                />
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body2" style={{ fontWeight: "bold" }}>
                  Usage limit
                </Typography>
                <TextfieldDefault
                  id="usageLimit"
                  name="usageLimit"
                  type="number"
                  label=""
                  disabled={true}
                  style={{
                    border: `1px solid ${theme.palette.background.entity_border}`,
                  }}
                  inputRef={register({
                    required: "Usage Limit is required.",
                    pattern: {
                      value: INTEGER_NUMBER_PATTERN,
                      message: "Invalid limit entered",
                    },
                  })}
                />
              </Grid> */}
              <Grid
                item
                xs={6}
                style={{ marginTop: "4px", marginBottom: "20px" }}
              >
                <Typography variant="body2" style={{ fontWeight: "bold" }}>
                  Applicable Platforms
                </Typography>
                <Autocomplete
                  open={isOpenPlatform}
                  onOpen={() => setIsOpenPlatform(true)}
                  onClose={() => setIsOpenPlatform(false)}
                  size={"small"}
                  id="locationSelectGlobal"
                  value={selectedPlatform || []} // Ensure value is always an array
                  getOptionLabel={(option) => option.label || ""}
                  color="inherit"
                  multiple={true}
                  options={platformList}
                  disableClearable
                  onChange={handleChangePlatform}
                  classes={{ root: classes.autoComplete }}
                  popupIcon={<ArrowDropDownIcon color={"inherit"} />}
                  renderOption={(props: any) => {
                    return (
                      <Grid
                        container
                        {...props}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          zIndex: 0,
                          height: "20px",
                          marginBottom: "4px",
                        }}
                      >
                        <Grid item xs={12}>
                          <Typography
                            variant="body2"
                            className={classes.titleColor}
                          >
                            {props.label}
                          </Typography>
                        </Grid>
                      </Grid>
                    );
                  }}
                  // renderTags={(value, props) =>
                  //   value.map((option, index) => (
                  //     <Chip label={option} {...props({ index })} />
                  //   ))
                  // }
                  renderInput={(params: any) => (
                    <TextField
                      color="inherit"
                      {...params}
                      label=""
                      variant="outlined"
                    />
                  )}
                />
                {isPlatformEmpty && (
                  <ValidationMessage message={"Platform is required."} />
                )}
              </Grid>
            </Grid>

            <AvailabilitySelection
              nodeData={{ availability: availabilitySelectionList }}
              backgroundColor="entity_background"
              disabled={false}
              handleSubmit={handleSubmitAvailability}
              setAvailabilityErrorMessage={setAvailabilityErrorMessage}
              title={"Set Availability Times"}
            />
            <Grid container spacing={2}>
              <Grid
                item
                xs={12}
                style={{
                  placeItems: "center",
                  display: "flex",
                  justifyContent: "start",
                  paddingTop: "16px",
                }}
              >
                <FormControlLabel
                  style={{ marginLeft: "0px", marginRight: "0px" }}
                  control={<SwitchCommon />}
                  checked={isSwitchActive}
                  onChange={handleSelectSwitchActivate}
                  label="Limited Time"
                  labelPlacement="start"
                />{" "}
              </Grid>

              {isSwitchActive && (
                <Grid item xs={6}>
                  <Typography variant="body2" style={{ fontWeight: "bold" }}>
                    From Date
                  </Typography>
                  <KeyboardDatePicker
                    autoOk
                    label=""
                    value={fromDate}
                    onChange={handleChangeFromDate}
                    inputVariant={"outlined"}
                    fullWidth
                    margin="normal"
                    className={classes.datePickerStyle}
                    format="dd/MM/yyyy"
                    okLabel={<Typography color="secondary">Ok</Typography>}
                    cancelLabel={
                      <Typography color="secondary">Cancel</Typography>
                    }
                    InputProps={{
                      style: {
                        borderRadius: 10,
                        height: 56,
                        backgroundColor:
                          theme.palette.background.entity_background,
                      },
                    }}
                  />
                </Grid>
              )}
              {isSwitchActive && (
                <Grid item xs={6}>
                  <Typography variant="body2" style={{ fontWeight: "bold" }}>
                    To Date
                  </Typography>
                  <KeyboardDatePicker
                    autoOk
                    label=""
                    value={toDate}
                    onChange={handleChangeToDate}
                    inputVariant={"outlined"}
                    fullWidth
                    margin="normal"
                    className={classes.datePickerStyle}
                    okLabel={<Typography color="secondary">Ok</Typography>}
                    cancelLabel={
                      <Typography color="secondary">Cancel</Typography>
                    }
                    InputProps={{
                      style: {
                        borderRadius: 10,
                        height: 56,
                        backgroundColor:
                          theme.palette.background.entity_background,
                      },
                    }}
                    format="dd/MM/yyyy"
                  />
                </Grid>
              )}
              <Grid item xs={12}>
                {(selectedOfferType.id === "BUY_X_GET_Y_CHEAPEST_DISCOUNTED" ||
                  selectedOfferType.id === "FIXED_PRICE_FOR_X_ITEMS") && (
                  <FirstTwoTypesGroup
                    register={register}
                    errors={errors}
                    handleOpenProductsAddModal={handleOpenProductsAddModal}
                    selectedWrapperIdList={selectedWrapperIdList}
                    isMembersEmpty={isMembersEmpty}
                    selectedOfferType={selectedOfferType.id}
                  />
                )}
              </Grid>
              {selectedOfferType?.id === "BUY_X_GET_Y_CHEAPEST_DISCOUNTED" && (
                <Grid item xs={12}>
                  <Typography variant="body2" style={{ fontWeight: "bold" }}>
                    Get (number of discounted items)
                  </Typography>
                  <Typography variant="caption" style={{ paddingTop: "12px" }}>
                    Number of items that will receive a discount (e.g. cheapest
                    free or 50% off). (Example: in “Buy 2 get 1 free”, this
                    would be 1.)
                  </Typography>
                  <TextfieldDefault
                    id="discountedQuantity"
                    name="discountedQuantity"
                    type="number"
                    label=""
                    style={{
                      border: `1px solid ${theme.palette.background.entity_border}`,
                    }}
                    inputRef={register({
                      required: "Discounted Quantity is required.",
                      pattern: {
                        value: INTEGER_NUMBER_PATTERN,
                        message: "Invalid limit entered",
                      },
                      min: {
                        value: 1,
                        message: "Discounted Quantity greater than 0",
                      },
                    })}
                  />
                  {errors.discountedQuantity ? (
                    <ValidationMessage
                      message={errors.discountedQuantity.message}
                    />
                  ) : (
                    ""
                  )}
                </Grid>
              )}

              {selectedOfferType?.id === "BUY_X_GET_Y_CHEAPEST_DISCOUNTED" && (
                <Grid
                  item
                  xs={selectedDiscountMethod?.id === "FREE" ? 6 : 4}
                  style={{ marginTop: "4px", marginBottom: "4px" }}
                >
                  <Typography variant="body2" style={{ fontWeight: "bold" }}>
                    Discount Method
                  </Typography>
                  <Autocomplete
                    open={isOpenDiscountMethod}
                    onOpen={() => setIsOpenDiscountMethod(true)}
                    onClose={() => setIsOpenDiscountMethod(false)}
                    size={"small"}
                    id="locationSelectGlobal"
                    value={selectedDiscountMethod || []} // Ensure value is always an array
                    getOptionLabel={(option) => option.label || ""}
                    color="inherit"
                    options={discountMethodList}
                    disableClearable
                    disabled={
                      selectedOfferType.id !== "BUY_X_GET_Y_CHEAPEST_DISCOUNTED"
                    }
                    onChange={handleChangeDiscountMethod}
                    classes={{ root: classes.autoComplete }}
                    popupIcon={<ArrowDropDownIcon color={"inherit"} />}
                    renderOption={(props: any) => {
                      return (
                        <Grid
                          container
                          {...props}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            zIndex: 0,
                            height: "20px",
                            marginBottom: "4px",
                          }}
                        >
                          <Grid item xs={12}>
                            <Typography
                              variant="body2"
                              className={classes.titleColor}
                            >
                              {props.label}
                            </Typography>
                          </Grid>
                        </Grid>
                      );
                    }}
                    // renderTags={(value, props) =>
                    //   value.map((option, index) => (
                    //     <Chip label={option} {...props({ index })} />
                    //   ))
                    // }
                    renderInput={(params: any) => (
                      <TextField
                        color="inherit"
                        {...params}
                        label=""
                        variant="outlined"
                      />
                    )}
                  />
                  {isSelectedMethodEmpty && (
                    <ValidationMessage
                      message={"Please Select Discount Method."}
                    />
                  )}
                </Grid>
              )}

              {selectedOfferType.id === "BUY_X_GET_Y_CHEAPEST_DISCOUNTED"
                ? selectedDiscountMethod?.id !== "FREE" && (
                    <Grid item xs={4}>
                      <Typography
                        variant="body2"
                        style={{ fontWeight: "bold" }}
                      >
                        Discounted Percentage
                      </Typography>
                      <TextfieldDefault
                        key={`${selectedOfferType.id}-${selectedDiscountMethod?.id}`}
                        id="discountValue"
                        name="discountValue"
                        type="number"
                        label=""
                        style={{
                          border: `1px solid ${theme.palette.background.entity_border}`,
                        }}
                        inputRef={register({
                          required: "Fixed Total Price is required.",
                          min: {
                            value: 1,
                            message:
                              "Fixed Total Price must be greater than 0.",
                          },
                          ...(selectedOfferType.id ===
                            "BUY_X_GET_Y_CHEAPEST_DISCOUNTED" &&
                          selectedDiscountMethod?.id === "PERCENTAGE"
                            ? {
                                pattern: {
                                  value: /^[0-9]+$/,
                                  message: "Only whole numbers are allowed.",
                                },
                              }
                            : {}),
                        })}
                        inputProps={{
                          ...(selectedOfferType.id ===
                            "BUY_X_GET_Y_CHEAPEST_DISCOUNTED" &&
                          selectedDiscountMethod?.id === "PERCENTAGE"
                            ? { step: 1 }
                            : { step: "0.01" }),
                          min: 1,
                        }}
                      />
                      {errors.discountValue ? (
                        <ValidationMessage
                          message={errors.discountValue.message}
                        />
                      ) : (
                        ""
                      )}
                    </Grid>
                  )
                : selectedOfferType?.id && (
                    <Grid item xs={12}>
                      <Typography
                        variant="body2"
                        style={{ fontWeight: "bold" }}
                      >
                        Fixed Total Price
                      </Typography>
                      <TextfieldDefault
                        id="fixedTotalPrice"
                        name="fixedTotalPrice"
                        type="number"
                        label=""
                        style={{
                          border: `1px solid ${theme.palette.background.entity_border}`,
                        }}
                        inputRef={register({
                          required: "Fixed Total Price is required.",
                          min: {
                            value: 1,
                            message: "Fixed Total Price greater than 0",
                          },
                        })}
                      />
                      {errors.fixedTotalPrice ? (
                        <ValidationMessage
                          message={errors.fixedTotalPrice.message}
                        />
                      ) : (
                        ""
                      )}
                    </Grid>
                  )}

              {selectedOfferType?.id === "BUY_X_GET_Y_CHEAPEST_DISCOUNTED" && (
                <Grid
                  item
                  xs={selectedDiscountMethod?.id === "FREE" ? 6 : 4}
                  style={{ marginTop: "4px", marginBottom: "4px" }}
                >
                  <Typography variant="body2" style={{ fontWeight: "bold" }}>
                    Apply To
                  </Typography>
                  <Autocomplete
                    open={isOpenApplyTo}
                    onOpen={() => setIsOpenApplyTo(true)}
                    onClose={() => setIsOpenApplyTo(false)}
                    size={"small"}
                    id="locationSelectGlobal"
                    value={selectedApplyTo || []} // Ensure value is always an array
                    getOptionLabel={(option) => option.label || ""}
                    color="inherit"
                    options={applyToList}
                    disableClearable
                    onChange={handleChangeApplyTo}
                    classes={{ root: classes.autoComplete }}
                    popupIcon={<ArrowDropDownIcon color={"inherit"} />}
                    renderOption={(props: any) => {
                      return (
                        <Grid
                          container
                          {...props}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            zIndex: 0,
                            height: "20px",
                            marginBottom: "4px",
                          }}
                        >
                          <Grid item xs={12}>
                            <Typography
                              variant="body2"
                              className={classes.titleColor}
                            >
                              {props.label}
                            </Typography>
                          </Grid>
                        </Grid>
                      );
                    }}
                    // renderTags={(value, props) =>
                    //   value.map((option, index) => (
                    //     <Chip label={option} {...props({ index })} />
                    //   ))
                    // }
                    renderInput={(params: any) => (
                      <TextField
                        color="inherit"
                        {...params}
                        label=""
                        variant="outlined"
                      />
                    )}
                  />
                  {isApplyToEmpty && (
                    <ValidationMessage message={"Please Select Apply To."} />
                  )}
                </Grid>
              )}
              {selectedOfferType?.id && (
                <Grid item xs={6}>
                  <FormControlLabel
                    control={<SwitchCommon />}
                    checked={isAllowRepeatInBasket}
                    onChange={handleAllowRepeatInBasketActivate}
                    style={{
                      marginLeft: "2px",
                      marginBottom:
                        selectedOfferType.id === "FIXED_PRICE_FROM_X_LISTS"
                          ? "0px"
                          : "20px",
                    }}
                    label={
                      <Typography variant="caption" color="textSecondary">
                        Allow Repeat In Basket
                      </Typography>
                    }
                    labelPlacement="start"
                  />
                </Grid>
              )}
              {(selectedOfferType.id === "BUY_X_GET_Y_CHEAPEST_DISCOUNTED" ||
                selectedOfferType.id === "FIXED_PRICE_FOR_X_ITEMS") && (
                <Grid item xs={12} style={{ marginBottom: "20px" }}>
                  <ButtonCommon
                    style={{
                      flex: 1,
                      fontSize: 11,
                      marginRight: 4,
                      width: "100%",
                      marginBottom: "12px",
                      display: "flex",
                      justifyContent: "space-between",
                      textTransform: "none",
                    }}
                    variant="contained"
                    color={"green"}
                    onClick={handleOpenProductsAddModal}
                  >
                    <Typography style={{ color: "white" }}>
                      {(() => {
                        const counts = Object.values(
                          selectedWrapperIdList,
                        ).reduce((acc: any, item: any) => {
                          return acc + Object.keys(item).length;
                        }, 0);

                        return `${counts} ${
                          counts === 1 ? "product" : "products"
                        } selected`;
                      })()}
                    </Typography>
                    <Typography style={{ color: "white" }}>
                      Set Products
                    </Typography>
                  </ButtonCommon>
                  {isMembersEmpty && (
                    <ValidationMessage message={"Members can not be empty"} />
                  )}
                </Grid>
              )}
              {selectedOfferType.id === "FIXED_PRICE_FROM_X_LISTS" && (
                <ThirdTypeGroup
                  setGroupInfo={setGroupInfo}
                  groupInfo={groupInfo}
                  isMembersEmptyOrMinTwo={isMembersEmpty}
                  offerItemMap={offerItemMap}
                  setOfferItemMap={setOfferItemMap}
                  offerItemMapInitial={offerItemMapInitial}
                  selectedWrapperIdListInitialNew={
                    selectedWrapperIdListInitialNew
                  }
                  isActive={isActive}
                  offerName={nodeData.name}
                />
              )}
            </Grid>
            <div
              style={{
                display: "flex",
                justifyContent: "end",
                marginBottom: "12px",
              }}
            >
              <ButtonCommon
                isLoadingPage={isLoadingButton}
                style={{
                  flex: 1,
                  fontSize: 11,
                  marginRight: 4,
                  minWidth: 160,
                }}
                variant="contained"
                color={"yellow"}
                onClick={() => {
                  setOpenDialog(false);
                  setOfferItemMap(offerItemMapInitial);
                }}
              >
                Cancel
              </ButtonCommon>
              <ButtonCommon
                isLoadingPage={isLoadingButton}
                style={{
                  flex: 1,
                  fontSize: 11,
                  marginRight: 4,
                  minWidth: 160,
                  marginLeft: 20,
                }}
                variant="contained"
                color={"orange"}
                isDisabled={buttonDisabled}
                onClick={handleSubmitData}
              >
                {submitButtonName.UPDATE_SUBMIT_BUTTON}
              </ButtonCommon>
            </div>
          </Grid>
        </DialogContent>
      </DialogCommonDefault>
      <ProductModal
        isOpen={isOpenProductsAddModal}
        setIsOpen={setIsOpenProductsAddModal}
        selectedWrapperIdList={selectedWrapperIdList}
        handleSubmitRewardsTypePoints={handleSubmitRewards}
        isEdit={false}
        rewardId={editableRewardId}
        isLoadingButton={isLoadingButton}
        handleSelectProduct={handleSelectProduct}
        setSelectedWrapperIdList={setSelectedWrapperIdList}
        selectedWrapperIdListInitial={selectedWrapperIdListInitial}
        offerItemMap={offerItemMap}
        selectedWrapperIdListInitialNew={selectedWrapperIdListInitialNew}
        setOfferItemMap={setOfferItemMap}
        offerItemMapInitial={offerItemMapInitial}
      />
      <AlertDialog
        open={isOpenSuccessModal}
        confirmAction={handleCloseSuccessModal}
        title="Confirm Offer Creation"
        desc={"Are you sure you want to create this new offer?"}
        severity="warning"
        confirmLabel="Ok"
        cancelAction={() => setIsOpenSuccessModal(false)}
        cancelLabel={"cancel"}
        disableBackdropClick
        color={"secondary"}
      />
    </>
  );
};

export default EditOfferModal;
